import { render, staticRenderFns } from "./UploadMyProgram.vue?vue&type=template&id=86220482&scoped=true&"
import script from "./UploadMyProgram.vue?vue&type=script&lang=js&"
export * from "./UploadMyProgram.vue?vue&type=script&lang=js&"
import style0 from "./UploadMyProgram.vue?vue&type=style&index=0&id=86220482&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86220482",
  null
  
)

export default component.exports